import { trackEvent } from '@modules/tracking/tracking.js'

/**
 * Trackers for Article guide card layout
 */
const articleElementSelector = `.article-element[data-order]`
const selectors = `.article ${articleElementSelector} h3 a, .article ${articleElementSelector} a.card-head`
document.querySelectorAll(selectors).forEach((element) => {
    element.addEventListener('click', () => {
        const container = element.closest('.article-element')

        let value = parseInt(container.dataset.order) || 0

        value++

        const label = element.getAttribute('title') || element.textContent
        const action = element.dataset.action !== 'popup' ? 'Title link' : 'Title link (popup)'

        trackEvent(action, {
            category: 'Article element',
            label: label,
            value: value,
        })
    })
})

document
    .querySelectorAll(`.article .article-element[data-order] .read-more-link`)
    .forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.article-element')
            let value = parseInt(container.dataset.order) || 0

            value++

            const label = element.getAttribute('title') || element.textContent
            const action =
                element.dataset.action !== 'popup' ? 'Read more link' : 'Read more link (popup)'

            trackEvent(action, {
                category: 'Article element',
                label: label,
                value: value,
            })
        })
    })

document.querySelectorAll('.article-content .body-text a').forEach((element) => {
    element.addEventListener('click', function () {
        if (
            this.href &&
            (!this.dataset || !this.dataset.action) &&
            !new RegExp(location.host).test(this.href) &&
            /^(https?:)?\/\//.test(this.href)
        ) {
            trackEvent('External link', {
                category: 'Article',
                label: this.href,
            })
            if (this.target === '_blank') {
                this.classList.add('referral-page')
            }
        }
    })
})
